import { useAuthContext, type AuthState } from './AuthContext';

export function useAuth(): AuthState {
  return useAuthContext();
}
